import { ExtraBedsStateInterface } from '.';

function state(): ExtraBedsStateInterface {
  return {
    extraBeds: [],
  };
}

export default state;
